import { z } from 'zod';
import { pl } from 'zod/locales';

export { ZodType } from 'zod';

const locale = pl();

z.config({
    localeError: (issue) => {
        if (
            (issue.code === 'invalid_type' &&
                issue.expected === 'string' &&
                issue.input === null) ||
            (issue.code === 'too_small' &&
                issue.origin === 'string' &&
                issue.minimum === 1)
        ) {
            return 'Pole wymagane';
        }

        if (
            issue.code === 'too_small' &&
            issue.origin === 'string' &&
            issue.minimum > 1
        ) {
            return `Pole wymaga ${issue.minimum} znaków`;
        }

        if (
            issue.code === 'invalid_value' &&
            issue.values.length === 1 &&
            issue.values[0] === true &&
            issue.input === false
        ) {
            return 'Zaznacz wymagane zgody';
        }

        return locale.localeError(issue);
    },
});

export { z };
